import {isNumber} from 'lodash-es';

export const convertWidthData = (metaWidth: string | number | undefined) => {
    if (metaWidth) {
        return isNumber(metaWidth) ? `${metaWidth}px` : `${parseInt(metaWidth, 10)}px`;
    }
    return undefined;
};
